// Floating top-right nav — site links + tour replay. Glass pill to match
// the rest of the map chrome. Lives where the view-toggle used to; the
// view-toggle moved into the sidebar's "Map views" section.
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { startTour } from './onboarding-tour';

export function TopNav() {
  const { t } = useTranslation();
  const cls =
    'inline-flex h-7 items-center gap-1.5 rounded-md px-2.5 text-[12px] font-medium text-[var(--color-text-2)] transition-colors hover:bg-[var(--color-surface-2)] hover:text-[var(--color-accent)]';
  return (
    <nav className="surface-glass pointer-events-auto inline-flex items-center gap-0.5 p-0.5">
      <a href="/history" className={cls}>{t('nav.history')}</a>
      <a href="/about" className={cls}>{t('nav.about')}</a>
      <a href="/faq" className={cls}>{t('nav.faq')}</a>
      <button
        type="button"
        onClick={() => startTour()}
        title={t('sidebar.tour_link')}
        className={cls}
      >
        <HelpCircle size={13} strokeWidth={2.25} />
        {t('sidebar.tour_link')}
      </button>
    </nav>
  );
}
